export default class Accordion {
	constructor(el) {
		this.accordion(el);
	}

	accordion(el) {
		$(el).find('.sl-accordion.active .sl-accordion-body, .sl-accordion-orders.active .sl-accordion-body').slideDown();

		$(el).on('click', '.sl-accordion-header', event => {
			const accordion = $(event.currentTarget);

			if (accordion.parent().hasClass('active')) {
				$('.sl-accordion, .sl-accordion-orders').removeClass('active');
				$('.sl-accordion-body').slideUp();
			} else {
				$('.sl-accordion, .sl-accordion-orders').removeClass('active');
				$('.sl-accordion-body').slideUp();
				accordion.parents('.sl-accordion, .sl-accordion-orders').addClass('active');
				accordion.parents('.sl-accordion, .sl-accordion-orders').find('.sl-accordion-body').slideDown();
			}
		});
	}
}
